export { default } from './DialogTitle';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/DialogTitle/index.js
// module id = 168
// module chunks = 0